import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Label as LabelComponent,
  LabelHeader,
  LabelHeaderCustom,
  LabelMarginBottom,
  LabelMenu,
} from './styles';

class Label extends Component {
  render() {
    // props
    const { text } = this.props;

    //types
    const { marginBottom, header, headerCustom, menu } = this.props;

    if (header) {
      return <LabelHeader className="notranslate">{text}</LabelHeader>;
    }

    if (headerCustom) {
      return <LabelHeaderCustom>{text}</LabelHeaderCustom>;
    }

    if (menu) {
      return <LabelMenu>{text}</LabelMenu>;
    }

    if (marginBottom) {
      return <LabelMarginBottom>{text}</LabelMarginBottom>;
    }

    return (
      <>
        <LabelComponent>{text}</LabelComponent>
      </>
    );
  }
}

Label.propTypes = {
  // props
  text: PropTypes.string,

  // types
  header: PropTypes.bool,
  headerCustom: PropTypes.bool,
  menu: PropTypes.bool,
  marginBottom: PropTypes.bool,
};

export default Label;
